module.exports = __webpack_public_path__ + "img/ArtistPage2.8123587e.png";